import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import { StaticContext, ErrorCard, TabletScreen } from '@sm/webassets';
import { getClientEnvironmentDetails } from '@sm/utils';

import NavBar from '../../components/NavBar';
import SearchBox from '../../components/SearchBox';
import AppListingList from '../../components/AppListingList';
import AppListingSkeleton from '../../components/AppListingList/AppListingSkeleton';
import AppDirectoryBasePage from '../AppDirectoryBasePage';

import { publishedApplicationListings } from './listings.graphql';

const LISTINGS_FETCH_LIMIT = 50;

const ListingsBasePage = ({ pageId, filter, title }) => {
  const {
    environment: { languageId },
    userAgent
  } = useContext(StaticContext);
  const { isDesktop } = getClientEnvironmentDetails(userAgent);

  return (
    <AppDirectoryBasePage
      id={pageId}
      navbar={
        <>
          <TabletScreen defaultMatches={isDesktop}>
            <div className="wds-m-b-4">
              <SearchBox />
            </div>
          </TabletScreen>
          <NavBar />
        </>
      }
    >
      <Query
        query={publishedApplicationListings}
        variables={{
          language: languageId,
          filter,
          page: 1,
          pageSize: LISTINGS_FETCH_LIMIT
        }}
      >
        {({ loading, error, data }) => {
          return (
            <Choose>
              <When condition={error}>
                <ErrorCard />
              </When>
              <When condition={loading}>
                <AppListingSkeleton />
              </When>
              <Otherwise>
                <AppListingList
                  title={title}
                  apps={data.publishedApplicationListings.items}
                />
              </Otherwise>
            </Choose>
          );
        }}
      </Query>
    </AppDirectoryBasePage>
  );
};

ListingsBasePage.propTypes = {
  pageId: PropTypes.string.isRequired,
  filter: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default ListingsBasePage;
